<template>
    <nav v-if="!loadingData">
        <AlertMessages
            v-if="alertValue"
            :alert-type="alertType" 
            :alert-msg="alertMsg"
            @reset="alertValue = false"
        />
        <v-row align="center" justify="center" class="fill-height">
            <v-col cols="11" class="mx-auto px-0">
                <v-row v-if="Object.keys(storeProduct).length > 0" class="fill-height" justify="center">
                    <v-col cols="12" md="5">
                        <v-img class="rounded-xxl mt-14" :src="storeProduct.attributes.image" max-height="400" ></v-img>
                    </v-col>
                    <v-col cols="12" md="5" offset-md="1">
                            <v-img
                                v-if="logo == null"
                                data-testid="logo-space"
                                src="../../assets/rtplogo.svg"
                                height="40"
                                max-width="150"
                                width="auto"
                                class="d-none d-sm-block justify-center mb-4 default"
                                contain
                    
                            />
                            <v-img
                                v-else
                                data-testid="logo-space"
                                :src="logo"
                                height="40"
                                max-width="150"
                                width="auto"
                                class="d-none d-sm-block justify-center mb-4"
                                position="top left"
                                contain
                                
                            />
                        <p class="text-h4 mb-10">{{ storeProduct.attributes.title }}</p>
                        <p class="mb-10 grey--text content-block" v-html="storeProduct.attributes.description"></p>
                        <p class="mb-0" data-testid="product-price">{{ $t('storeOrderPricePerPerson') }}<span class="d-block font-weight-bold">{{ storeProduct.attributes.currency.code }} {{ price }}</span></p>

                        <br>
                        <br>
                        <v-btn :disabled="registerDisabled || storeProduct.attributes.participants_seats_left === 0" class="rounded-xxl text-none white--text" color="darktext" :dark="!registerDisabled && storeProduct.attributes.participants_seats_left > 0" @click="redirectToRegisterProduct" data-testid="register-btn">{{ $t('register') }}</v-btn>
                        <br>
                        <br>
                        <p v-if="storeProduct.attributes.participants_seats_left !== null" data-testid="product-available-seats" class="success--text">{{ $t('storeOrderAvailableSeats') }}: {{ storeProduct.attributes.participants_seats_left }}</p>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </nav>
</template>
<script>
import { getStoreProductPublic } from '../../api/productApi'
import AlertMessages  from '../../components/AlertMessages'
import i18n from '../../plugins/i18n'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'

export default {
    components: {
        AlertMessages
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            alertType: '',
            alertMsg: '',
            alertValue:false,
            spaceId: window.$cookies.get('space_id'),
            loadingData: false,
            storeProduct: {},
            productID: this.$route.params.id,
            space: window.location.host.split('.')[0],
            registerDisabled: true,
            price:0,
            logo: localStorage.space ? JSON.parse(localStorage.space).logo : null,
        }
    },
    async created(){      
        this.loadingData = true
        await this.fetchStoreProduct()
        this.loadingData = false;
        i18n.locale = window.$cookies.get('language') ? window.$cookies.get('language') : window.$cookies.get('space_language') ? window.$cookies.get('space_language') : 'sv';
    },
    methods:{
        async fetchStoreProduct() {
            try {
                const response = await getStoreProductPublic(this.productID);
                if (response.status == 200) {
                    this.storeProduct = response.data.data
                    this.price = this.storeProduct.attributes.price.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true, style: 'decimal' }).replace(',', '.');
                    this.registerDisabled = false
                }
            } catch (e) {
                if(e.response){
                    if(e.response.status == 404) {
                        this.$router.push({name: 'PageNotFound'})
                    }
                    else if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else {
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },
        redirectToRegisterProduct() {
            this.$router.push({name: 'RegisterProductPublic', params: {id: this.productID}})
        }
    }
}
</script>